import { PerkDefinition } from "./types";

export const perkArmor: PerkDefinition<"perk_armor"> = {
  id: "perk_armor",
  name: "Iron Skin",
  description: "+2 Armor",
  apply: (context) => {
    context.addArmor(2);
  },
};
